import React, { useState } from "react";
import { Link } from "react-router-dom"; // Adjust as needed for your routing
import "./realestate.css"; // Use your appropriate CSS file; you may rename it if necessary
import HeroFooter from "../../components/footer";
import ScrollToTop from "./scrolltop";


const categories = [
  "Contract Management",
  "Foreign Collaborations",
  "Joint Ventures",
  "Corporate Law",
  "Information Technology",
  "Business Ventures",
  "MSME",
  "Start-up India Initiatives",
  "Property and Real Estate"
];

// Map each category to a custom slug
const categoryMapping = {
  "Contract Management": "contract",
  "Foreign Collaborations": "foreign",
  "Joint Ventures": "joint",
  "Corporate Law": "corporate",
  "Information Technology": "information",
  "Business Ventures": "buisness",
  "MSME": "msme",
  "Start-up India Initiatives": "startup",
  "Property and Real Estate": "realestate"
};

const ContractManagement = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };

// style={{ backgroundImage: `url(${backimg})` }}


  return (
    <div className="practice-page"  >
         <ScrollToTop/>
      {/* Mobile Menu Button visible on mobile */}
      <div className="mobile-menu-button" onClick={toggleSidebar}>
        <i className="fa fa-bars" aria-hidden="true"></i>
      </div>

      {/* Sidebar (Slider) */}
      <aside className={`sidebar ${sidebarOpen ? "open" : ""}`}>
        <h2 className="sidebar-title">Our Offerings</h2>
        <ul className="category-list">
          {categories.map((category, index) => (
            <li
              key={index}
              className={category === "Contract Management" ? "active" : ""}
            >
              <Link
                onClick={() => setSidebarOpen(false)}
                 to={`/${categoryMapping[category]}`}
              >
                {category}
              </Link>
            </li>
          ))}
        </ul>
      </aside>

      {/* Main Content Area */}
      <main className="conten">
        <h2>Contract Management</h2>
        <p className="intro">
          At InduratnaLaw, we offer comprehensive contract management solutions designed to streamline processes, mitigate risks, and ensure strict compliance with both national and international legal standards.
        </p>
        <section className="details">
          <h3>Our Expertise</h3>
          <p>
            Effective contract management is critical to reducing risk, ensuring consistency, and enhancing efficiency across legal operations. Our expert team assists in drafting, reviewing, and managing contracts so that every agreement not only protects your interests but also meets regulatory requirements.
          </p>
          <p>
            By leveraging advanced technology and best legal practices, we help track key dates, enforce contract terms, and maintain comprehensive records, ensuring that your organization remains agile and compliant.
          </p>
          <h3>Key Services</h3>
          <ul>
            <li>Contract Drafting and Review</li>
            <li>Risk Assessment and Mitigation</li>
            <li>Regulatory Compliance and Audits</li>
            <li>Performance Monitoring and Renewal Management</li>
            <li>Data-Driven Contract Analytics</li>
          </ul>
          <h3>Why Choose InduratnaLaw?</h3>
          <p>
            With years of industry experience and a client-first approach, our team transforms contract management into a strategic advantage. Our solutions combine cutting-edge technology with proven legal strategies to create a streamlined, secure, and robust framework for handling your contractual agreements.
          </p>
        </section>
      </main>

      <HeroFooter />
    </div>
  );
};

export default ContractManagement;
